
<div class="overlay" *ngIf="ShowProfitFilter || ShowNewProfitSettings || ShowProfitsContainer || ShowDeleteLogoQuestion || ShowDeleteBrandQuestion || showAddNewBrand || showAddNewWarehouse || ShowDeleteWarehouseQuestion || showAddNewWHZone || ShowDeleteWHZoneQuestion;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProfitMessage">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteProfitMessage = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false; DeleteProfitSettings();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewProfitSettings == true;">
  <div class="NewProfitSettingsContainerTitle" *ngIf="this.ProfitSettings?.ID == 0 && !this.ProfitSettings.IsCopy;">
    <i class="material-icons">add</i>
    <span>{{'AddNewProfitSettings' | translate}}</span>
  </div>
  <div class="NewProfitSettingsContainerTitle" *ngIf="this.ProfitSettings?.ID > 0 && !this.ProfitSettings.IsCopy;">
    <i class="material-icons">edit</i>
    <span>{{'ModifyProfitSettings' | translate}}</span>
  </div>
  <div class="NewProfitSettingsContainerTitle" *ngIf="this.ProfitSettings.IsCopy == true;">
    <i class="material-icons">content_copy</i>
    <span>{{'CopyProfitSettings' | translate}}</span>
  </div>
  <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewProfitSettings = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="NewProfitSettingsContainerBody">

    <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SearchPartners' | translate}}*</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SearchPartners' | translate}}"
               matInput
               (click)="InitializePartners();"
               [matAutocomplete]="auto9"
               [(ngModel)]="this.PartnerSearchTerm"
               (ngModelChange)="this.partnerSearchTermUpdate.next($event)">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.PartnerSearchTerm?.length > 0;" (click)="this.ProfitSettings.PartnerID = null; this.ProfitSettings.PartnerName = ''; this.PartnerSearchTerm = null;">close</i>
        <i style="height: 25px; line-height:25px;" *ngIf="(this.PartnerSearchTerm?.length > 0) != true;" class="material-icons BrandSelectCloseIcon">search</i>
        <mat-autocomplete #auto9="matAutocomplete">
          <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.ProfitSettings.PartnerID = p.ID; this.ProfitSettings.PartnerName = p.Name; this.PartnerSearchTerm = p.Name;">
            {{p.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.PercentageImpact?.PercentageProfitMargin != null">
      <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
        <mat-label>% {{ 'OurProfit' | translate }}*</mat-label>
        <input disabled="true" matInput placeholder="{{ 'OurProfit' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.PercentageImpact.PercentageProfitMargin">
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SearchConfiguration' | translate}}"
               matInput
               (click)="InitializeImportConfigurations();"
               [matAutocomplete]="auto3"
               [(ngModel)]="this.ConfigurationTerm"
               (ngModelChange)="this.configSearchTermUpdate.next($event)">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.ConfigurationTerm?.length > 0;" (click)="this.ProfitSettings.ImportConfiguration = null; this.ConfigurationTerm = ''; this.ProfitSettings.DiscountGroup = null;">close</i>
        <i style="height: 25px; line-height:25px;" *ngIf="(this.ConfigurationTerm?.length > 0) != true;" class="material-icons BrandSelectCloseIcon">search</i>
        <mat-autocomplete #auto3="matAutocomplete">
          <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectConfiguration(c);">
            {{c.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.ImportConfiguration?.DiscountedGroups?.length > 0;">
      <mat-form-field appearance="outline"class="BrandSelectContainer" style="margin-left: 5%;">
        <mat-label>{{ 'SearchGroup' | translate }}</mat-label>
        <mat-select name="SearchGroup" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.DiscountGroup">
          <mat-option *ngFor="let g of this.ProfitSettings?.ImportConfiguration?.DiscountedGroups" [value]="g">
            {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
          </mat-option>
        </mat-select>
      </mat-form-field>
     </div>

   <div class="NewProfitSettingsContainerBodyRow">
    <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
      <mat-label>{{'SelectBrand' | translate}}</mat-label>
      <input class="BrandSelect"
             type="text"
             placeholder="{{'SelectBrand' | translate}}"
             matInput
             [matAutocomplete]="auto1"
             [(ngModel)]="this.BrandSearchTerm"
             (ngModelChange)="this.brandSearchTermUpdate.next($event)"
             (click)="InitializeBrands();">
      <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrandProfitSettings();">close</i>
      <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
      <mat-autocomplete #auto1="matAutocomplete">
        <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand;">
          {{brand.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
   </div>

   <div class="NewProfitSettingsContainerBodyRow">
    <mat-form-field appearance="outline"class="BrandSelectContainer" style="margin-left: 5%;" matTooltip="{{this.ProfitSettings?.PercentageImpact?.Description}}" matTooltipClass='neutral-tool-tip-management'>
      <mat-label>{{ 'ProfitSettingsPercentageImpact' | translate }}</mat-label>
      <mat-select name="ProfitSettingsPercentageImpact" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.PercentageImpact">
        <mat-option *ngFor="let p of this.ProfitSettingsPercentageImpacts" [value]="p">
          {{p.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
   </div>

   <div class="NewProfitSettingsContainerBodyRow">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
      <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 0;">{{ 'PriceListDiscountClient' | translate }}*</mat-label>
      <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 1;">{{ 'PureProfitFromPurchasePrice' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'Percentage' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.Percentage">
    </mat-form-field>
   </div>

   <div class="NewProfitSettingsContainerBodyRow">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
      <mat-label>{{ 'ExtraAddedValue' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'ExtraAddedValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedValue">
    </mat-form-field>
   </div>

   <div class="NewProfitSettingsContainerBodyRow">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
      <mat-label>{{ 'ExtraAddedPercentageValue' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'ExtraAddedPercentageValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedPercentageValue">
    </mat-form-field>
   </div>
  </div>

  <div class="NewProfitSettingsContainerCommands">
    <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="AddUpdatePartnerProfitSettings();" *ngIf="this.ProfitSettings.IsCopy != true;">
      <span>{{'SaveButton' | translate}}</span>
      <i class="material-icons">save_alt</i>
    </button>

    <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="AddUpdatePartnerProfitSettings();" *ngIf="this.ProfitSettings.IsCopy == true;">
      <span>{{'CopyProfitSettings' | translate}}</span>
      <i class="material-icons">content_copy</i>
    </button>

    <button mat-raised-button color="warn" style="background: #fd4f57;" class="SaveProfitSettingsButton" (click)="this.ShowDeleteProfitMessage = true;">
      <span>{{'Delete' | translate}}</span>
      <i class="material-icons">close</i>
    </button>
  </div>
</div>

<div class="NewProductContainer animated fadeInDown" *ngIf="this.ShowProfitsContainer == true;">
  <div class="NewProductContainerTitleBar">
    <p>{{'ProfitSettings' | translate}}</p>
    <i class="material-icons" (click)="ShowProfitsContainer = false;">close</i>
  </div>

  <div class="NewProductContainerBody">
    <div class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
      <div class="ColumnTitle">
        <i class="material-icons" style=" font-size: 30px;">monetization_on</i>
        {{'ProfitSettings' | translate}}
      </div>

      <div class="ColumnTitle">
        <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
        <span matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
      </div>

      <div class="fullWidth">

        <div class="ProfitSettingsTable">
          <button mat-raised-button color="primary" class="AddNewProfitButton" (click)="OpenNewProfitSettings();">
            <i class="material-icons">add</i>
            <span>{{'AddNewProfitSettings' | translate}}</span>
          </button>
        </div>

        <div class="ProfitSettingsTable">
          <div class="ProfitSettingsRow ProfitSettingsHeadder">
            <div class="ProfitSettingsCol" style="width: 5%;">
              <span>#</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 20%;">
              <span>{{'Client' | translate}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{'DiscountGroup' | translate}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{'ImportConfiguration' | translate}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{'Brand' | translate}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{'Percentage' | translate}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{'Profit' | translate}}</span>
            </div>
          </div>

          <div class="ProfitSettingsRow" *ngFor="let ps of this.PartnerProfitSettings; let i=index;" (click)="EditProfitSettings(ps);">
            <div class="ProfitSettingsCol" style="width: 5%;">
              <span>{{i + 1}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 20%;">
              <span>{{ps.PartnerName}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
              <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{ps.ImportConfiguration?.Name}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span>{{ps.Brand?.Name}}</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}%</span>
            </div>

            <div class="ProfitSettingsCol" style="width: 15%;">
              <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
            </div>
          </div>

        </div>
      </div>
     
    </div>
  </div>

  <div class="NewProductContainerCommands">
    <button mat-raised-button color="primary" class="AddNewProductButton" (click)="ShowProfitsContainer = false;">
      <i class="material-icons">check</i>
      {{'Ok' | translate}}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteLogoQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteLogoQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteLogoQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteLogoQuestion = false;DeleteBrandLogo();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBrandQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteBrandQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBrandQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBrandQuestion = false;DeleteBrand();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteWarehouseQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteWarehouseQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteWarehouseQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteWarehouseQuestion = false;DeleteWarehouse();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteWHZoneQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteWHZoneQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteWHZoneQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteWHZoneQuestion = false;DeleteWHZone();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="AddNewBrandContainer animated fadeInDown" *ngIf="showAddNewBrand == true;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="showAddNewBrand = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AddNewBrand' | translate }}
  </div>
  <div class="InfoQuestionBody">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
      <mat-label>{{ 'BrandName' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'BrandName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.NewBrand.Name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
      <mat-label>{{ 'AlternativeName' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'AlternativeName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.NewBrand.Alternative">
    </mat-form-field>
  </div>

  <div class="InfoQuestionCommands" style="margin-bottom: 10px;">
    <button mat-raised-button class="MainCommandButton" style="margin-left: 5%;" (click)="AddUpdateBrand(this.NewBrand);">
      <i class="material-icons">add</i>
      {{'AddNewBrand' | translate}}
    </button>
  </div>
</div>

<div class="AddNewBrandContainer animated fadeInDown" *ngIf="showAddNewWarehouse == true;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="showAddNewWarehouse = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AddNewWarehouse' | translate }} {{this.parent.Company.Name}}
  </div>
  <div class="InfoQuestionBody">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
      <mat-label>{{ 'WarehouseName' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'WarehouseName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.NewWarehouse.Name">
    </mat-form-field>

  <mat-form-field appearance="outline" class="fullWidth" style="width: 80%;">
    <mat-label>{{ 'WarehouseAddress' | translate }}</mat-label>
    <mat-select name="WarehouseAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewWarehouse.Address">
      <mat-option *ngFor="let a of this.NewWarehouse.Company.Addresses" [value]="a">
        {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  </div>

  <div class="InfoQuestionCommands" style="margin-bottom: 10px;">
    <button mat-raised-button class="MainCommandButton" style="margin-left: 5%;" (click)="AddUpdateWarehouse(this.NewWarehouse);">
      <i class="material-icons">add</i>
      {{'AddNewWarehouse' | translate}}
    </button>
  </div>
</div>

<div class="AddNewBrandContainer animated fadeInDown" *ngIf="showAddNewWHZone == true;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="showAddNewWHZone = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    <span *ngIf="this.NewWHZone.ID == 0;">
      {{ 'AddWHZone' | translate }}: {{this.Warehouse.Name}}
    </span>
    <span *ngIf="this.NewWHZone.ID > 0;">
      {{ 'EditWHZone' | translate }}: {{this.Warehouse.Name}}
    </span>
  </div>
  <div class="InfoQuestionBody">
    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 100%;">
      <mat-label>{{ 'WHZoneName' | translate }}*</mat-label>
      <input matInput placeholder="{{ 'WHZoneName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.NewWHZone.Name">
    </mat-form-field>
  
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>{{ 'WHZoneDescription' | translate }}</mat-label>
      <textarea autocomplete="off" matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="5"
                [(ngModel)]="this.NewWHZone.Description"></textarea>
    </mat-form-field>

  </div>

  <div class="InfoQuestionCommands" style="margin-bottom: 10px;">
    <button mat-raised-button class="MainCommandButton" style="margin-left: 5%;" (click)="AddUpdateWHZone(this.NewWHZone);">
      <i class="material-icons">add</i>
      <span *ngIf="this.NewWHZone.ID == 0;">{{'AddWHZone' | translate}}</span>
      <span *ngIf="this.NewWHZone.ID > 0;">{{'EditWHZone' | translate}}</span>
    </button>
  </div>
</div>

<div class="PageContent">
    <div class="PageContentTitle">
        <i class="material-icons">construction</i>
        {{'DataConfiguration' | translate}}
    </div>
    <div class="PageContentBody animated fadeIn">
        <mat-tab-group (selectedTabChange)="tabClick($event)">
            <mat-tab label="{{ 'Brands' | translate }}">
              <div class="TabContainer">
                <div *ngIf="this.Brand != null;" class="TabTitle">
                    {{this.Brand?.Name}}
                    <div class="BrandTopLogoContainer" *ngIf="this.Brand?.LogoPath?.length > 0;">
                        <img [src]="this.parent.BackendServiceUrl + this.Brand?.LogoPath" />
                    </div>
                </div>
                <p *ngIf="this.Brand == null;" class="TabTitle" style="border: none;">{{'Brands' | translate}}</p>

                <div class="OneThirdColumn">
                    <div class="ColumnTitle">
                        <i class="material-icons">search</i>
                        {{'SelectBrand' | translate}}
                    </div>

                    <mat-form-field class="BrandSelectContainer" appearance="outline">
                        <mat-label>{{'SelectBrand' | translate}}</mat-label>
                        <input class="BrandSelect"
                               type="text"
                               placeholder="{{'SelectBrand' | translate}}"
                               matInput
                               [matAutocomplete]="auto1"
                               [(ngModel)]="this.BrandFilter.SearchTerm"
                               (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                               (click)="InitializeBrands();">
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandFilter?.SearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandFilter?.SearchTerm?.length > 0) != true;">search</i>
                        <mat-autocomplete #auto1="matAutocomplete">
                          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandFilter.SearchTerm = '';">
                            {{brand.Name}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <button mat-raised-button color="accent" class="AddNewBrandButton" (click)="OpenAddNewBrand();">
                        <i class="material-icons">add</i>
                        {{'AddNewBrand' | translate}}
                      </button>

                      <button style="margin-left: 25px;" mat-raised-button color="primary" class="AddNewBrandButton" (click)="ShowProfitsContainer = true; GetPartnerProfitSettings();" *ngIf="this.Brand?.ID > 0;">
                        <i class="material-icons">radio_button_on</i>
                        {{'ProfitSettings' | translate}}
                      </button>
                </div>
                <div class="TwoThirdsColumnWithGap" *ngIf="this.Brand != null;">
                    <div class="ColumnTitle">
                        <i class="material-icons">radio_button_checked</i>
                        {{'GeneralInformation' | translate}}
                    </div>

                    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
                        <mat-label>{{ 'BrandName' | translate }}*</mat-label>
                        <input matInput placeholder="{{ 'BrandName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Brand.Name">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
                        <mat-label>{{ 'AlternativeName' | translate }}*</mat-label>
                        <input matInput placeholder="{{ 'AlternativeName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Brand.Alternative">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
                        <mat-label>{{ 'Logo' | translate }}*</mat-label>
                        <input disabled="true" matInput placeholder="{{ 'Logo' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Brand.LogoPath">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
                      <mat-label>{{ 'StandardPercentageProfit' | translate }}*</mat-label>
                      <input matInput placeholder="{{ 'StandardPercentageProfit' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Brand.StandardPercentageProfit">
                    </mat-form-field>

                    <mat-form-field appearance="outline" matTooltip="{{'BrandRankDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                      <mat-label>Rank</mat-label>
                      <input matInput type="number" [(ngModel)]="Brand.Rank" [min]="0" step="1" placeholder="Enter rank" />
                    </mat-form-field>

                    <div class="ColumnTitle">
                        <i class="material-icons">radio_button_checked</i>
                        {{'Logo' | translate}}
                    </div>
    
                      <div class="fullWidth">
                        <form [formGroup]="newBrandLogo" (ngSubmit)="AddUpdateBrandLogo()">
                          <div style="margin-bottom: 15px;">
                              <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                          </div>
                          <button type="submit" mat-raised-button>{{ 'UploadLogo' | translate }}</button>
                        </form>
                      </div>

                      <div class="fullWidth">
                        <button mat-raised-button class="MainCommandButton" style="background: #f60;" (click)="ShowDeleteLogoQuestion = true;">
                            <i class="material-icons">close</i>
                            {{'DeleteLogo' | translate}}
                        </button>
                      </div>

                      <div class="fullWidth" style="margin-top: 20px;">
                        <button mat-raised-button class="MainCommandButton" style="background: #f44336;" (click)="ShowDeleteBrandQuestion = true;">
                            <i class="material-icons">close</i>
                            {{'DeleteBrand' | translate}}
                        </button>
                      </div>

                    <div class="fullWidth" style="margin-top: 25px;">
                        <button mat-raised-button class="MainCommandButton" (click)="AddUpdateBrand(this.Brand);">
                            <i class="material-icons">save_alt</i>
                            {{'Update' | translate}}
                        </button>
                    </div>
                </div>
              </div>

            </mat-tab>
            <mat-tab label="{{ 'Warehouses' | translate }}">
              <div class="TabContainer">
                <div *ngIf="this.Warehouse != null;" class="TabTitle">
                    {{this.Warehouse?.Name}}
                </div>
                <p *ngIf="this.Warehouse == null;" class="TabTitle" style="border: none;">{{'Warehouses' | translate}}</p>

                <div class="OneThirdColumn">
                    <div class="ColumnTitle">
                        <i class="material-icons">search</i>
                        {{'SelectWarehouse' | translate}}
                    </div>

                    <mat-form-field class="BrandSelectContainer" appearance="outline">
                        <mat-label>{{'SelectWarehouse' | translate}}</mat-label>
                        <input id="warehouseselectid" class="BrandSelect"
                               type="text"
                               placeholder="{{'SelectWarehouse' | translate}}"
                               matInput
                               [matAutocomplete]="auto2"
                               [(ngModel)]="this.WarehouseFilter.SearchTerm"
                               (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                               (click)="InitializeWarehouses();">
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.WarehouseFilter?.SearchTerm?.length > 0;" (click)="ClearSearchWarehouse();">close</i>
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.WarehouseFilter?.SearchTerm?.length > 0) != true;">search</i>
                        <mat-autocomplete #auto2="matAutocomplete">
                          <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Warehouse = warehouse; this.WarehouseFilter.SearchTerm = '';GetWarehouse(this.Warehouse.ID);">
                            {{warehouse.Name}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <button mat-raised-button color="accent" class="AddNewBrandButton" (click)="OpenAddNewWarehouse();">
                        <i class="material-icons">add</i>
                        {{'AddNewWarehouse' | translate}}
                      </button>

                      <div class="fullWidth" style="margin-top: 50px;" *ngIf="this.Warehouse != null;">
                        <button mat-raised-button class="MainCommandButton" style="background: #f44336;" (click)="ShowDeleteWarehouseQuestion = true;">
                              <i class="material-icons">close</i>
                              {{'DeleteWarehouse' | translate}}
                        </button>
                      </div>
      
                      <div class="fullWidth" style="margin-top: 10px;" *ngIf="this.Warehouse != null;">
                          <button mat-raised-button class="MainCommandButton" (click)="AddUpdateWarehouse(this.Warehouse);">
                              <i class="material-icons">save_alt</i>
                              {{'Update' | translate}}
                          </button>
                      </div>
                </div>
                <div class="TwoThirdsColumnWithGap" *ngIf="this.Warehouse != null;">
                  <div class="ColumnTitle">
                    <i class="material-icons">radio_button_checked</i>
                    {{'GeneralInformation' | translate}}
                  </div>

                <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 80%;">
                    <mat-label>{{ 'WarehouseName' | translate }}*</mat-label>
                    <input matInput placeholder="{{ 'WarehouseName' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Warehouse.Name">
                </mat-form-field>

                <mat-slide-toggle class="IsPartnerWarehouseToggle" [(ngModel)]="this.Warehouse.IsPartnerWarehouse">{{'IsPartnerWarehouse' | translate}}</mat-slide-toggle>

                <div class="AddressLine" *ngIf="this.Warehouse.Partner != null && this.Warehouse.IsPartnerWarehouse == true;">
                  {{'SelectedPartner' | translate}}: {{Warehouse.Partner.Name}}
                </div>

                <mat-form-field class="BrandSelectContainer" appearance="outline" *ngIf="this.Warehouse.IsPartnerWarehouse == true;" style="width: 80%;">
                  <mat-label>{{'SelectPartner' | translate}}</mat-label>
                  <input class="BrandSelect"
                         type="text"
                         placeholder="{{'SelectPartner' | translate}}"
                         matInput
                         [matAutocomplete]="auto11"
                         [(ngModel)]="this.PartnersFilter.SearchTerm"
                         (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                         (click)="InitializePartners();">
                  <mat-autocomplete #auto11="matAutocomplete">
                    <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Warehouse.Partner = p; this.PartnersFilter.SearchTerm = p.Name;">
                      {{p.Name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <div class="AddressLine" *ngIf="this.Warehouse.Address != null && this.Warehouse.IsPartnerWarehouse == true;">
                  {{'ActiveAddress' | translate}}: {{Warehouse.Address?.City}} {{Warehouse.Address?.AddressLine}} 
                </div>

                <mat-form-field class="BrandSelectContainer" appearance="outline" *ngIf="this.Warehouse.IsPartnerWarehouse == true;" style="width: 80%;">
                  <mat-label>{{'SelectAddress' | translate}}</mat-label>
                  <input class="BrandSelect"
                         type="text"
                         placeholder="{{'SelectAddress' | translate}}"
                         matInput
                         [matAutocomplete]="auto10"
                         [(ngModel)]="this.AddressesFilter.Product"
                         (ngModelChange)="this.addressSearchTermUpdate.next($event)"
                         (click)="InitializeAddresses();">
                  <mat-autocomplete #auto10="matAutocomplete">
                    <mat-option *ngFor="let a of Addresses" [value]="a" (click)="this.Warehouse.Address = a; this.AddressesFilter.Product = a.City +' '+ a.AddressLine;">
                      {{a.City}}, {{a.AddressLine}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="fullWidth" style="width: 80%;" *ngIf="this.Warehouse.IsPartnerWarehouse != true;">
                  <mat-label>{{ 'WarehouseAddress' | translate }}</mat-label>
                  <mat-select name="WarehouseAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Warehouse.Address">
                    <mat-option *ngFor="let a of this.Warehouse.Company.Addresses" [value]="a">
                      {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="fullWidth">
                  <mat-form-field appearance="outline" class="BrandSelectContainer" style="width: 10%;" *ngIf="this.Warehouse.StockLeadTime != null">
                    <mat-label>{{'Units' | translate}}</mat-label>
                    <input matInput placeholder="{{'Units' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Warehouse.StockLeadTime.Units">
                  </mat-form-field>
                 
                  <mat-form-field appearance="outline" class="fullWidth" style="width: 70%;" *ngIf="this.Warehouse.StockLeadTime != null">
                    <mat-label>{{ 'LeadTimeType' | translate }}</mat-label>
                    <mat-select name="WarehouseAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Warehouse.StockLeadTime.Type">
                      <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                        {{t.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-slide-toggle *ngIf="this.Warehouse.StockLeadTime?.Type != null;" class="IsPartnerWarehouseToggle" [(ngModel)]="this.Warehouse.StockLeadTime.Type.IsWorkDays">{{'IsWorkDays' | translate}}</mat-slide-toggle>
                </div>

                <div class="ColumnTitle">
                  <i class="material-icons">location_on</i>
                  {{'WarehouseZones' | translate}}
                </div>

                <div class="WHZonesContainer" *ngIf="WHZones != null && WHZones.length > 0;">
                  <div *ngFor="let zone of this.WHZones" class="WHZone">
                    {{zone.Name}}
                    <i class="material-icons" style="color:red;" (click)="this.NewWHZone = zone; this.ShowDeleteWHZoneQuestion = true;">close</i>
                    <i class="material-icons" style="color:#0082e6;" (click)="this.NewWHZone = zone;this.showAddNewWHZone = true;">edit</i>
                  </div>
                </div>

                <div class="fullWidth" style="margin-top: 10px;">
                  <button mat-raised-button class="MainCommandButton" (click)="OpenAddNewWHZone();">
                      <i class="material-icons">add</i>
                      {{'AddWHZone' | translate}}
                  </button>
                </div>

                </div>
              </div>
            </mat-tab>
            <mat-tab label="{{ 'ProfitSettings' | translate }}">
              <div class="TabContainer">
              <p class="TabTitle" style="border: none;">{{'ProfitSettings' | translate}}</p>
              
              <div class="TabProfitsContainer">
                <div class="ColumnTitle">
                  <i class="material-icons" style=" font-size: 30px;">monetization_on</i>
                  {{'ProfitSettings' | translate}}
                </div>
          
                <div class="ColumnTitle">
                  <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
                  <span matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
                </div>

                <div class="fullWidth">

                  <div class="ProfitSettingsTable">
                    <button mat-raised-button color="primary" class="AddNewProfitButton" (click)="OpenNewProfitSettings();">
                      <i class="material-icons">add</i>
                      <span>{{'AddNewProfitSettings' | translate}}</span>
                    </button>
                  </div>
          
                  <div class="ProfitSettingsTable">
                    <div class="ProfitSettingsRow ProfitSettingsHeadder">
                      <div class="ProfitSettingsCol" style="width: 5%;">
                        <span>#</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 20%;">
                        <span>{{'Client' | translate}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;">
                        <span>{{'DiscountGroup' | translate}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;">
                        <span>{{'ImportConfiguration' | translate}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;">
                        <span>{{'Brand' | translate}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;">
                        <span>{{'Percentage' | translate}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 10%;">
                        <span>{{'Profit' | translate}}</span>
                      </div>

                      <div class="ProfitSettingsCol" style="width: 5%;">
                        <span>{{'Actions' | translate}}</span>
                      </div>
                    </div>
          
                    <div class="ProfitSettingsRow" *ngFor="let ps of this.PartnerProfitSettings; let i=index;">
                      <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                        <span>{{i + 1}}</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 20%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                        <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                        <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                        <span *ngIf="ps.DiscountGroup == null;">-----</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                        <span *ngIf="ps.ImportConfiguration == null;">-----</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                        <span *ngIf="ps.Brand == null;">-----</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                        <span *ngIf="ps.Percentage == null;">-----</span>
                      </div>
          
                      <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                        <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                        <span *ngIf="ps.PercentageImpact == null;">-----</span>
                      </div>

                      <div class="ProfitSettingsCol" style="width: 5%;" (click)="CopyProfitSettingsUI(ps);">
                        <i class="material-icons">content_copy</i>
                      </div>
                    </div>
          
                  </div>
                </div>

              </div>
                
              </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
